<template>
  <v-flex class="text-sm-center">
    <template v-if="loading">
        <skeleton-loader v-for="index in 6"
                         :key="index"
                         class="mx-2 v-btn v-btn--icon theme--light"
                         circle
                         animation="fade"
                         :width="56"
                         :height="56"></skeleton-loader>
    </template>
    <v-tooltip v-else
               top
               v-for="(item, index) in items"
               :key="index">
      <template v-slot:activator="{ on }">
        <v-btn class="mx-2 v-btn v-btn--icon theme--light"
               icon
               dark
               round
               fab
               :loading="loading"
               v-on="on"
               :color="'nx-neutral-200'"
               :href="item.url">
          <v-icon :color="'nx-neutral-700'">{{ item.icon }}</v-icon>
        </v-btn>
      </template>
      <span>{{ translate(item.text) }}</span>
    </v-tooltip>

  </v-flex>
</template>

<script>
import SkeletonLoader from '@/components/skeleton/SkeletonLoader';
import { translateCandidates } from '@/utils';

export default {
  name: 'nx-dashboard-menu-card',
  components: {
    SkeletonLoader,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  computed: {
    loading() {
      return this.items.length === 0;
    },
  },
  methods: {
    translate(translatable) {
      return translateCandidates(
        [
          `message.${translatable}`,
          translatable,
        ],
        translatable,
      );
    },
  },
};
</script>
